import { h } from 'preact';
import FormStructure from '../../client_forms/solepower/form_structure.js';
import { store, updateFormField } from '../../state/formState'; 
import FormField from '../form/form_field';

const Step1 = ({ update, errors = {} }) => {
  const stepFields = ['EventDate', 'Category', 'SiteName'];

  // Search the layout for these specific fields
  const fields = FormStructure.layout.rows
    .flatMap(row => row.fields)
    .filter(field => stepFields.includes(field.mapping));

  const orderedFields = stepFields.map(key => fields.find(f => f.mapping === key)).filter(Boolean);

  const todayStr = new Date().toISOString().split('T')[0];

  return (
    <div className="step-inner">
      <h2>Tell us about your event and we'll take it from there.</h2>
      
      {orderedFields.map(field => (
        <div key={field.mapping}>
          <FormField 
            config={field} 
            value={store.formData[field.mapping] || ''}
            error={errors[field.mapping]} 
            autoComplete="off"
            min={field.mapping === 'EventDate' ? todayStr : null}
            onInput={(val) => {
              updateFormField(field.mapping, val);
              update(); 
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default Step1;